export default __webpack_public_path__ + "static/media/message-template-image.e9bcd2db.webp";